import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatNumberWithSpaces } from 'pages/calculator/MediaPlanning/common/BudgetTable/utils/formatNumberWithSpaces';
import { useMemo } from 'react';
import { CountryFormState } from '../../../../../store/planStore';
import { getBudgetTotals } from '../../Plan/PlanSummary/helpers/helpers';

export interface TotalBudgetSummaryProps {
  countryForms: Record<string, Partial<CountryFormState>>;
}

export function TotalBudgetSummary({ countryForms }: TotalBudgetSummaryProps) {
  const { t } = useTranslation();

  const dep = JSON.stringify(countryForms);

  const { totalBudget, firstCurrency, totalTechCost } = useMemo(
    () => getBudgetTotals(countryForms),
    [dep]
  );

  return (
    <Grid
      container
      sx={{ p: '24px 46px 24px 15px', backgroundColor: 'tableBackground.main' }}
    >
      {/* TOTAL BUDGET */}
      <Grid
        item
        xs={12}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Typography textTransform="uppercase" fontSize={18} fontWeight={700}>
          {t('mediaPlanning.totalBudget')}
        </Typography>
        <Typography fontWeight={700} fontSize={18}>
          {`${formatNumberWithSpaces(totalBudget.toFixed(0))} ${firstCurrency}`}
        </Typography>
      </Grid>

      {/* TECH COSTS */}
      <Grid
        item
        xs={12}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Typography textTransform="uppercase" variant="body2" fontWeight={700}>
          {t('mediaPlanning.techCosts')}
        </Typography>
        <Typography fontWeight={700} variant="body2">
          {`${formatNumberWithSpaces(
            totalTechCost.toFixed(0)
          )} ${firstCurrency}`}
        </Typography>
      </Grid>
    </Grid>
  );
}
